export const PARSERS = [
  { value: 'keyword_transform', label: 'Преобразование ключевого слова' },
  { value: 'text_fill_bank',    label: 'Текст с пропусками и банком слов' },
  { value: 'lexics',            label: 'Лексика' },
];

export const FORM_TYPES = [
  { value: 'keyword_transform', label: 'Преобразование ключевого слова' },
  { value: 'text_fill_bank',    label: 'Текст с пропусками (банк снизу)' },
  { value: 'lexics',            label: 'Лексика (банк справа)' },
];
